import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { techModules } from '@/mocks/tech';

export default function TechCards() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            title="三大核心技术能力，一个完整基础设施"
            subtitle="从 AI 交互入口到数字货架再到物联网连接，三项技术协同构成县域数字商业的完整基础设施。"
          />
        </Reveal>

        <div className="mt-12 flex flex-col gap-5">
          {techModules.map((item, i) => (
            <Reveal key={item.no} delay={i * 70}>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200 hover:bg-white hover:border-primary-300 transition-colors flex flex-col md:flex-row md:items-start gap-5 md:gap-8">
                {/* 左侧：图标 + 编号 */}
                <div className="flex items-center justify-between md:flex-col md:items-center md:gap-3 md:min-w-[80px]">
                  <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${item.icon} text-primary-600 text-2xl`}></i>
                  </div>
                  <span className="font-heading font-bold text-2xl text-background-300 md:text-xl">
                    {item.no}
                  </span>
                </div>

                {/* 右侧：内容 */}
                <div className="flex-1 flex flex-col">
                  <h3 className="font-heading font-bold text-lg text-foreground-950">
                    {item.title}
                  </h3>
                  <div className="mt-1 text-sm text-accent-600 font-medium">{item.subtitle}</div>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {item.features.map((f) => (
                      <span
                        key={f}
                        className="px-2.5 py-1 text-[11px] rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap"
                      >
                        {f}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}